<!-- VERSIONE SENZA STATO ENTITÀ -->
<ng-template [ngIf]="!statoEntitaTemplate">
  <div
    role="radiogroup"
    class="radiogroup row"
    [attr.aria-describedby]="groupHelpId"
  >
    <!-- Etichetta del gruppo -->
    <!-- <div [id]="groupLabelId" class="radiogroup-label">
      {{ gruppoTitolo || 'Seleziona un’opzione' }}
      <span *ngIf="mandatory" class="mandatory" aria-hidden="true">*</span>
    </div> -->

    <!-- Aiuto screen reader -->
    <small [id]="groupHelpId" class="sr-only">
      Usa le frecce per cambiare selezione.
    </small>

    <!-- Opzioni -->
    <div
      *ngFor="let item of radioButtonOptions; let i = index"
      class="radio-option {{classCol}}"
    >
      <input
        type="radio"
        class="custom-radio-input"
        name="{{ nameRadio }}"
        [id]="nameRadio + '_' + i + randomId"
        [checked]="isChecked(item.id)"
        [disabled]="submitPending"
        [attr.aria-checked]="isChecked(item.id)"
        (change)="onChange(item)"
        [attr.aria-required]="mandatory && i === 0 ? 'true' : null"
      />

      <!-- Label con contenitore visivo custom -->
      <label
        [for]="nameRadio + '_' + i + randomId"
        class="custom-radio-label"
      >
        <span class="custom-radio-visual"></span>
        {{ item.label }}
      </label>
    </div>
  </div>
</ng-template>

<!-- VERSIONE CON STATO ENTITÀ -->
<ng-template [ngIf]="statoEntitaTemplate">
  <div
    role="radiogroup"
    [attr.aria-labelledby]="nameRadio + '_groupLabel_' + randomId"
    [attr.aria-describedby]="nameRadio + '_help_' + randomId"
    class="radiogroup row"
  >
    <div
      [id]="nameRadio + '_groupLabel_' + randomId"
      class="fakelabel"
    >
      {{ statoTemplateTitle }}
      <span *ngIf="mandatory" aria-hidden="true" class="mandatory radiobutton">*</span>
    </div>

    <small [id]="nameRadio + '_help_' + randomId" class="sr-only">
      Usa le frecce per cambiare opzione.
    </small>

    <ng-template ngFor let-item [ngForOf]="radioButtonOptions" let-i="index">
      <div class="radio-option {{classCol}}">
        <input
          type="radio"
          name="{{ nameRadio }}"
          class="custom-radio-input"
          id="{{ nameRadio + '_' + i + randomId }}"
          [checked]="isChecked(item.id)"
          [disabled]="submitPending"
          (change)="onChange(item)"
          [attr.aria-checked]="isChecked(item.id)"
          [attr.aria-required]="mandatory && i === 0 ? 'true' : null"
        />

        <label
          for="{{ nameRadio + '_' + i + randomId }}"
          class="custom-radio-label"
        >
          <span class="custom-radio-visual"></span>
          {{ item.label }}
        </label>
      </div>
    </ng-template>
  </div>
</ng-template>
